import Vue from 'vue'
var api = {

  /* 公共接口 */
  common: {
    /* 1.记录异常日志 */
    addExceptionLog: '/basics-boot/log/addExceptionLog',
    // 获取微信code
    getWeChatOpenId: '/oauth-boot/oauth/getWeChatOpenId',
    // 链接配置
    getTenantByDomainArray: '/basics-boot/jurisdiction/getTenantByDomainArray',
    // 发送验证码
    sendVerifyCode: '/message-boot/message/sms/sendVerifyCode',
    // 初步验证短信验证码
    preliminarySubmitVerifyCode: '/message-boot/message/sms/preliminarySubmitVerifyCode',
    // 发送评论
    send: '/message-boot/message/comment/send',
    // 获取评论列表
    listComments: '/message-boot/message/comment/listComments',
    /* 获取图形验证码并验证字符串 */
    getImageVerifyCode: '/message-boot/message/sms/getImageVerifyCode',
    // 绑定手机号
    bindPhone: '/oauth-boot/oauth/bindPhone',
    // 获取子菜单列表
    listSubMenu: '/match-boot/menu/listSubTreeMenu',
    // 文件上传
    upload: '/fastdfs-boot/upload',
    // 获取OSS签名
    getOssSign: '/basics-boot/oss/getSign',
    // 根据域名获取赛道id
    getTrackId: '/match-boot/index/getTrackId',
    // 根据域名获取赛道名称
    getTrackName: '/match-boot/index/getTrackName',
    // 根据父代码获取子菜单（树结构）
    listSubTreeMenu: '/match-boot/menu/listSubTreeMenu',
    // 获取赛道首页配置
    getTrackHome: '/match-boot/index/getTrackHome',
    // 选择子级管理列表
    selectSubManageList: '/match-boot/index/selectSubManageList',
    // 申请赛事平台
    applyManage: '/match-boot/manageInfo/applyManage',
    // 获取大赛通用类型字典
    getMatchComType: '/match-boot/matchInfo/getMatchComType',
    // 获取学校列表（检索）
    querySchoolList: '/basics-boot/university/queryList',
    // 获取机构信息
    listSubNormArea: '/match-boot/matchInfo/listSubNormArea',
    // 分页获取选择子级管理列表
    selectSubManagePage: '/match-boot/index/selectSubManagePage',
    // 获取管理树结构（成为管理员用到）
    selectManageTree: '/match-boot/index/selectManageTree',
    // 3.18查看编辑客户信息项信息
    getcustomerItem: '/oa-boot/customerItem/get',
    // 3.18根据年 月 用户ID 查询用户指派给她的任务的list
    pageTaskByDate: '/oa-boot/task/v2/pageTaskByDate',
    // 换token
    loginSubsystem: '/oauth-boot/oauth/subsystemLogin',
    // 3.18新增或编辑日报
    customeraddOrEdit: '/oa-boot/customer/v2/detail/addOrEdit',
    // 字典项数据
    treeFieldsByKey: '/basics-boot/dictionaries/tenant/treeFieldsByKey',
    // 文本编辑数据
    getRichText: '/basics-boot/richText/get',
    /* 撤回 */
    recall: '/message-boot/message/im/recall',
    /* 发送验证码 */
    sendVerifyCode: '/message-boot/message/sms/sendVerifyCode',
    // 根据租户id 和 appCode 获取其按钮权限
    listButtonByUserIdWithAppCode:
      '/basics-boot/jurisdiction/listButtonByUserIdWithAppCode',
    // 获取标签页列表（通用）
    listSpecialColumn: '/basics-boot/System/listSpecialColumn',
    // 获取我当前用户的本资源学习进度
    getMyMasterProgress: '/fastdfs-boot/learning/getMyMasterProgress',
    // 记录当前我这个资源的学习时长
    progressRecord: '/fastdfs-boot/learning/progressRecord',
    // 2022042001 点击常用客服问题调用的接口，自动回答客户答案
    sendCustomerServiceMsg: '/message-boot/message/im/sendCustomerServiceMsg',
    // 2022032601 全部设置为已读-只有自己的
    readAllDialogue: '/message-boot/message/dialogue/readAllDialogue',
    // 点击入驻类型，返回入驻对象
    getMyEnter: '/oauth-boot/enter/getMyEnter',
    // 202206151532--入驻管理V22022
    pageEnterListV2: '/oauth-boot/enter/pageEnterListV2',
    // 入驻管理列表
    getEnterList: '/oauth-boot/enter/pageEnterList',
    // 入驻信息
    getEnterInfo: '/oauth-boot/enter/getUserEnter',
    // 入驻管理审核通过或拒绝
    checkEnterInfo: '/oauth-boot/enter/checkUserEnter',
    // 增量获取消息列表
    listIncrementMsg: '/message-boot/message/dialogue/listIncrementMsg',
    // 获取我的消息列表
    listIncrementHistory: '/message-boot/message/dialogue/listIncrementHistory',
    /* 获取会话 */
    getDialogue: '/message-boot/message/im/getDialogue',
    /* 获取会话id */
    getSingleDialogueId: '/message-boot/message/im/getSingleDialogueId',
    /* 发送验证码 */
    sendVerifyCode: '/message-boot/message/sms/sendVerifyCode',
    // 提交认证信息
    submitEnter: '/oauth-boot/enter/submitEnter',
    getEnterInfoById: '/oauth-boot/enter/getEnterInfoById',
    /* 初步验证短信验证码 */
    preliminarySubmitVerifyCode:
      '/message-boot/message/sms/preliminarySubmitVerifyCode',
    /* 真验证短信验证码 */
    SubmitVerifyCode:
      '/message-boot/message/sms/submitVerifyCode',
    /* 获取图形验证码并验证字符串 */
    getImageVerifyCode: '/message-boot/message/sms/getImageVerifyCode',
    /* 获取滑动验证码图形 */
    getSlideVerify: '/message-boot/message/sms/getSlideVerify',
    /* 绑定手机号 */
    bindPhone: '/oauth-boot/oauth/bindPhone',

    /* 找回密码2 */
    findPwd: '/oauth-boot/oauth/findPwd',

    /* 用户注册 */
    register: '/oauth-boot/oauth/register',
    /* 微哨用户登陆 单点登录 */
    weishaoOpenId: '/oauth-boot/oauth/weishaoOpenId',
    /* 微哨用户绑定手机号 */
    weiShaoBindPhone: '/oauth-boot/oauth/weiShaoBindPhone',

    /* 用户登录 */
    login: '/oauth-boot/oauth/login',
    /* 通过手机号注册一个用户 */
    addOrEditMember: '/oauth-boot/member/addOrEditMember',
    // 获取用户是否已经注册了
    getUserInfoByTelephone: '/oauth-boot/member/getUserInfoByTelephone',
    /* 用户注销 */
    logout: '/oauth-boot/oauth/logout',

    /* 获取子菜单列表 */
    listSubMenu: '/basics-boot/menu/treeMyMenu',
    // 文件上传
    upload: '/fastdfs-boot/upload',
    // 20211118前端通用字典接口（列表）
    allFieldsByKey: '/basics-boot/dictionaries/tenant/allFieldsByKey',
    // (新)获取按钮权限
    getV2Permission: '/oa-boot/common/v2/getPermission',
    // 根据模块获取导出字段
    exportColumn: '/teachers-boot/common/exportColumn',
    // PC端获取生成二维码
    createQrCode: '/basics-boot/scan/createQrCode',
    // pc端定时查询二维码主表
    getQrCodeInfo: '/oauth-boot/oauth/getQrCodeInfo',
    // 获取检索字段配置(如果是下拉框带上选项数组)
    listConditionColumn: '/teachers-boot/common/listConditionColumn',
    // 获取人员类型等相关字段
    listBasicJa: '/teachers-boot/common/listBasicJa',
    // 获取基本信息
    getUserBaseInfo: '/oauth-boot/oauth/getUserBaseInfo',
    // 缓存导出字段
    cacheExportField: '/basics-boot/info/cacheExportField',
    // 导出抽签数据
    commonExport: '/basics-boot/export/commonExport',
    // 保存搜索
    addHistory: '/basics-boot/info/addHistory',
    // 获取历史搜索列表
    listHistory: '/basics-boot/info/listHistory',
    // 获取抽签列表表头
    drawListColumn: '/basics-boot/column/listColumn',
    // 删除一条指定的历史搜索条件
    delHistory: '/basics-boot/info/delHistory',
    // 回显一条历史搜索条件
    getHistory: '/basics-boot/info/getHistory',
    // 获取表头接口
    listColumn: '/basics-boot/common/listColumn',
    // 保存列头
    saveColumn: '/basics-boot/info/saveColumn',
    // 获取我的消息列表
    listHistoryDialogue: '/message-boot/message/dialogue/listHistoryDialogue',

    // 获取未读消息数
    getAllUnreadCount: '/message-boot/message/dialogue/getAllUnreadCount',
    // 获取会话详情
    listDialogueMsg: '/message-boot/message/dialogue/listDialogueMsg',
    // 发送消息
    sendMsg: '/message-boot/message/im/send',
    // 发送消息
    sendCustomerServiceMsg: '/message-boot/message/im/sendCustomerServiceMsg',
    // 获取客服聊天会话ID
    customerService: '/message-boot/message/im/customerService',

    // 产品详情咨询获取客服聊天会话ID
    getProductDialogId: '/message-boot/message/im/getProductDialogId',

    // 获取个人消息列表（用于h5页面，不根据会话id获取）
    listNoticeMsg: '/message-boot/message/notice/listNoticeMsg',
    // 获取待办列表
    listTodoMessage: '/oa-boot/message/listTodoMessage',
    // 获取未读消息数（待办、系统通知）
    getMessageCount: '/oa-boot/message/getMessageCount',
    // 发送评论
    send: '/message-boot/message/comment/send',
    // 获取评论列表
    listComments: '/message-boot/message/comment/listComments',
    //  删除用户自己配置的表头数据
    resetTableColumn: '/basics-boot/info/resetTableColumn',
    // 获取系统相对应的角色字典列表
    listCfgAppStrategy: '/oauth-boot/oauth/listCfgAppStrategy',
    // 换token
    loginSubsystem: '/oauth-boot/oauth/subsystemLogin',
    // 云赛事换token
    loginSubsystemForMatch: '/match-boot/oauth/loginSubsystemForMatch',
    // 00606004 获取掌业云首页配置
    getUniversityHome: '/basics-boot/product/getUniversityHome',
    // 002 用户短信登录
    smsLogin: '/oauth-boot/oauth/smsLogin',
    /* 1.记录异常日志 */
    addExceptionLog: '/basics-boot/log/addExceptionLog',
    // 获取树
    treeLabel: '/classroom-boot/label/treeLabel',
    // 获取树
    listSubLabel: '/classroom-boot/label/listSubLabel',
    // 获取子级列表，顶级传空或0,用于首页获取
    pageLabelCourse: '/classroom-boot/label/pageLabelCourse',
    // 按钮权限
    listButtonByUserIdWithAppCode:
      '/basics-boot/jurisdiction/listButtonByUserIdWithAppCode',
    // 按学校名称模糊搜索
    listByUniversityName: '/basics-boot/university/listByUniversityName',
    // 按学校名称模糊搜索
    topByUniversityName: '/basics-boot/university/topByUniversityName',
    // 根据学历层次和专业名称(模糊)获取专业列表
    listProfessionalByEducationCode:
      '/basics-boot/common/listProfessionalByEducationCode',
    // 搜索专业
    topProfessionalByEducationCode:
      '/basics-boot/common/topProfessionalByEducationCode',
    // 流程审批配置-表头字典
    treeFieldsByKey: '/basics-boot/dictionaries/tenant/treeFieldsByKey',
    // 动态获取隐私协议
    listByTenant: '/basics-boot/richText/listByTenant',
    // 20210120012800 获取教师承诺书下载地址/获取必填项配置
    getSystemConfig: '/basics-boot/info/getSystemConfig'

  },
  // 测评列表
  personnelList: {
    // 202210281625-获取测评列表
    evaluatingCodeList: '/enroll-boot/evaluating/evaluatingCodeList',
    // 202210311102获取测评链接
    evaluatingUrlCreate: '/enroll-boot/evaluating/evaluatingUrlCreate',
    // 202210311359-获取测评用户信息（查看自己）
    userFind: '/enroll-boot/evaluating/userFind',
    // 202211011422创建测评用户信息
    // 202211111413-测评APP二维码扫描验证接口
    scanQcCode: '/enroll-boot/evaluating/scanQcCode',

    userCreate: '/enroll-boot/evaluating/userCreate',
    // 202210311408用户信息修改
    userEdit: '/enroll-boot/evaluating/userEdit',
    // 获取pdf
    getReportPdf: '/enroll-boot/evaluating/getReportPdf'
  },
  /* 首页 */
  home: {
  // 修改密码
    modifyPwd: '/oauth-boot/oauth/modifyPwd',
    // 保存个人信息
    addOrUpdateBasicsUserInfo:
    '/classroom-boot/userInfo/addOrUpdateBasicsUserInfo',
    // 获取个人信息
    getBasicsUserInfo: '/classroom-boot/userInfo/getBasicsUserInfo',
    // 链接配置
    getUniversityCode: '/basics-boot/product/getUniversityCode',
    // 链接配置
    getTenantByDomainArray: '/basics-boot/jurisdiction/getTenantByDomainArray',
    // 链接配置
    universityProductList: '/basics-boot/product/universityProductList',
    // 链接配置
    listUniversityProduct: '/basics-boot/product/listUniversityProduct',
    // 获取云平台首页轮播图
    listSlideshow: '/match-boot/master/listSlideshow',
    // 获取云平台首页轮播图
    listViewpager: '/basics-boot/viewpager/listViewpager',
    // 分页获取主赛道(首页用)
    pageMasterTrack: '/match-boot/master/pageMasterTrack',
    // 首页内容
    zyyPcHomePage: '/classroom-boot/index/zyyPcHomePage',
    // 首页内容
    pageHomePageMaterial: '/classroom-boot/index/pageHomePageMaterial',
    // 是否需要刷脸
    whetherFaceRecognition: '/classroom-boot/face/whetherFaceRecognition',
    // 首页内容
    listViewShow: '/basics-boot/viewpager/listViewShow',
    // 获取新闻
    getNews: '/basics-boot/news/getNewsById',
    //   2020021401 推荐课程详情介绍
    getRecommendCoursesInfo:
    '/classroom-boot/courseInfo/getRecommendCoursesInfo',
    //   2020021401 推荐课程详情介绍
    courseWareTree: '/classroom-boot/index/courseWareTree',
    //  2020021501 根据课程id获取课堂id
    getClassroomId: '/classroom-boot/courseInfo/getClassroomId',
    //  报名
    attendCourse: '/classroom-boot/classroom/attendCourse',
    // /课程目录列表点击获取资源
    coursewareDetailByContrastId:
    '/classroom-boot/classroom/coursewareDetailByContrastId',
    // resourceDetail: '/classroom-boot/classroom/resourceDetail',
    // 直播详情
    getLiveDetail: '/basics-boot/teach/live/getLiveDetail',
    // 精品课程
    getQualityResourceInfoIntroduce:
    '/classroom-boot/resourceinfo/getQualityResourceInfoIntroduce',
    // 直播介绍
    getLiveIntroduction: '/basics-boot/live/getLiveIntroduction',
    // 00320031101 根据直播id获取直播详情
    getLiveMaster: '/basics-boot/live/getLiveMaster',
    // 首页判断完善信息接口
    isCompletedUserInfo: '/classroom-boot/userInfo/isCompletedUserInfo',
    // 是否报名过
    isExistEnroll: '/basics-boot/student/live/isExistEnroll',
    //
    readRecode: '/classroom-boot/chapterInfo/readRecode',
    // 查询开通培训的学校列表
    getTrainingUniversityList:
    '/classroom-boot/courseInfo/getTrainingUniversityList',
    // 获取课程及专栏信息
    getCoursesColumn: '/classroom-boot/courseInfo/getCoursesColumn',
    // 是否具有报名资格
    isExistTrainingQualified:
    '/classroom-boot/schoolDepartment/isExistTrainingQualified',
    // 考核标准
    listExamStandard: '/classroom-boot/examStandard/listExamStandard',
    // 202107211638 获取资源进度记录
    getResourceProgressRecord: '/classroom-boot/idc/getResourceProgressRecord',
    // 202107211635 添加资源进度记录
    addResourceProgressRecord: '/classroom-boot/idc/addResourceProgressRecord',
    // 获取我当前用户的本资源学习进度
    getMyMasterProgress: '/fastdfs-boot/learning/getMyMasterProgress',
    // 2022050402 记录当前我这个资源的学习时长
    progressRecord: '/fastdfs-boot/learning/progressRecord'
  },
  mail: {
  // 岗位列表
    pageDictPosition: '/basics-boot/position/pageDictPosition',
    // 用户列表
    findUserListByPosition: '/basics-boot/position/findUserListByPosition',
    // 添加修改岗位字典
    addOrEditDictPosition: '/basics-boot/position/addOrEditDictPosition',
    // 获取职责字典列表，返回是否已选择
    listDictResponsibilityByPosition:
    '/basics-boot/position/listDictResponsibilityByPosition',
    // 职位绑定职责，可用于删除绑定关系
    bindResponsibility: '/basics-boot/position/bindResponsibility',
    // 部门员工树，返回员工勾选状态
    listUser: '/basics-boot/position/listDepartmentAndUser',
    // 职位绑定用户，也可用于删除用户绑定关系
    bindUser: '/basics-boot/position/bindUser',
    // 获取所有部门信息
    listDepartment: '/basics-boot/department/listDepartment',
    // 删除（逻辑）部门
    delDepartment: '/basics-boot/department/delDepartment',
    // 添加或修改部门
    addOrEditDepartment: '/basics-boot/department/addOrEditDepartment',
    //  分页获取某部门下的成员信息
    pageMemberByDepartment: '/oa-boot/membership/pageMemberByDepartment',
    //  通过电话号码查找用户信息
    getUserInfoByTelephone: '/oa-boot/membership/getUserInfoByTelephone',
    //  回显一条成员记录
    getMember: '/oa-boot/membership/getMember',
    //  下拉列表展示：对应系统下的获得所有部门
    listAllDepartment: '/basics-boot/department/listAllDepartment',
    //  获取系统相对应的角色字典列表
    listDictRole: '/basics-boot/role/listDictRole',
    //  将成员添加到部门
    addMember: '/basics-boot/department/addMember',
    //  添加或编辑字典角色
    addOrEditDictRole: '/basics-boot/role/addOrEditDictRole',
    //  逻辑删除角色信息
    delDictRole: '/basics-boot/role/delDictRole',
    //  获取指定角色
    getDictRole: '/basics-boot/role/getDictRole',
    //  逻辑删除部门下的成员
    delMember: '/basics-boot/department/delMember',
    //  通讯录 编辑一条成员信息
    editMember: '/oa-boot/membership/editMember',
    //  获取一个指定的部门对象
    getDepartment: '/basics-boot/department/getDepartment',
    //  分页获取某角色下的成员信息
    pageMemberByRole: '/oa-boot/membership/pageMemberByRole',
    //  在角色下添加成员
    addRoleMember: '/basics-boot/role/addMember',
    //  在指定角色下逻辑删除成员
    delRuleMember: '/basics-boot/role/delMember',
    //  根据角色id获取菜单
    treeMenuByRole: '/basics-boot/menu/treeMenuByRole',
    //  更新角色下对应的菜单
    updateRecRoleMenu: '/basics-boot/menu/updateRecRoleMenu',
    unbindUser: '/basics-boot/position/unbindUser',
    // 20210125获取入职/离职记录分页
    pageEmploymentDeparture:
    '/basics-boot/employmentDeparture/pageEmploymentDeparture',
    // 20210125新增或者编辑用户入职/离职记录表
    addOrEditEmploymentDeparture:
    '/basics-boot/employmentDeparture/addOrEditEmploymentDeparture',
    // 20210125获取查看用户信息
    getEmploymentDeparture:
    '/basics-boot/employmentDeparture/getEmploymentDeparture',
    // 20210125删除离职用户
    deleteEmploymentDeparture:
    '/basics-boot/employmentDeparture/deleteEmploymentDeparture',
    // 20210125离职用户
    Departure: '/basics-boot/employmentDeparture/Departure',
    // 20210129 转试用、转正
    positive: '/basics-boot/employmentDeparture/positive',
    // 获取授权类型
    pageBusinessPermission: '/oa-boot/permission/pageBusinessPermission',
    // 修改授权人
    transferOrRemoveBusinessPermission:
    '/oa-boot/permission/transferOrRemoveBusinessPermission',
    // 修改虚拟号
    changeVirtualPhone: '/oauth-boot/oauth/changeVirtualPhone'
  },
  enroll: {
  // 根据招募id获取字段列表
    listFieldByRecruitId: '/enroll-boot/enroll/listFieldByRecruitId',
    // 新增（修改）录入学生信息
    addOrUpdateStu: '/enroll-boot/enroll/addOrUpdateStu',
    // 树形专业
    getTreeDictMajor: '/basics-boot/common/getTreeDictMajor'
  },
  customer: {
  // 202208081551-添加oa产品客服
    addImCustomerService: '/message-boot/message/callBack/addImCustomerService',
    // 202208081555-获取oa产品客服List
    listImCustomerService:
    '/message-boot/message/callBack/listImCustomerService',
    // 202208081552-删除oa产品客服
    delImCustomerService: '/message-boot/message/callBack/delImCustomerService'
  },
  myCourse: {
  // 是否报名过
    stuListCourses: '/classroom-boot/index/stuListCourses',
    // 00601 获取学生课库作业列表（分页）
    pageStuHomework: '/classroom-boot/homework/pageStuHomework',
    // 2020021101 获取作业题目列表（包含标准答案，题目提交状态、学生的答案）
    listStuHomeworkQuestion: '/classroom-boot/homework/listStuHomeworkQuestion',
    // 00602 提交题目，保存在临时字段中
    submitQuestion: '/classroom-boot/homework/submitQuestion',
    // 00603 提交作业包
    submitHomework: '/classroom-boot/homework/submitHomework'
  },

  /* 申请平台专家 */
  applyPlatformTutors: '/match-boot/admin/demand/applyPlatformTutors',

  // 我的运用
  apply: {
  // 抽签列表
    pageDrawByFlag: '/message-boot/drawUnion/pageDrawByFlag',
    // 创建或者编辑抽签
    addOrUpdateDraw: '/message-boot/drawUnion/addOrUpdateDraw',
    // 删除抽签
    delDraw: '/message-boot/drawUnion/delDraw',
    // 获取抽签详情
    getDrawByIdByPc: '/message-boot/drawUnion/getDrawByIdByPc',
    // 获取抽签详情
    getDrawResultPc: '/message-boot/drawUnion/getDrawResultPc',
    // 获取草稿
    getDraftDraw: '/message-boot/drawUnion/getDraftDraw',
    // 发布抽签
    publishDraw: '/message-boot/drawUnion/publishDraw',
    // 抽签列表
    pageDrawByFlag: '/message-boot/drawUnion/pageDrawByFlag',
    // 获取抽签成员列表
    pageDrawMember: '/message-boot/drawUnion/pageDrawMember',
    // 添加一个手机号用户
    addDrawMember: '/message-boot/drawUnion/addDrawMember',
    // 删除一个抽签用户
    deleteDrawMember: '/message-boot/drawUnion/deleteDrawMember'
  },
  /** 支付 */
  pay: {
  /* 011042704 某账号下的充值记录/消费记录（分页） */
    pageConsumeByStatus: '/order-boot/account/pageConsumeByStatus',
    /* 011042901 充值掌币 */
    rechargeBalance: '/order-boot/account/rechargeBalance',
    /* 0110616 获取我的掌币余额 */
    getMyAccount: '/order-boot/account/getMyAccount',
    /* 011042801 根据商品id和商品类型得到订单特殊字段(商品是否收费，用户是否已购，商品原价，定价)*/
    getOrderJson: '/order-boot/account/getOrderJson',
    /* 001042701 下订单并支付的*/
    createAndPayOrder: '/order-boot/account/createAndPayOrder',
    /* 011061602 根据消费记录id查找该充值记录是否成功*/
    paySuccessByOrderNo: '/order-boot/account/paySuccessByOrderNo'
  },

  // 自定义建站

  customWeb: {
  // 202205171539-获取有勾选的菜单Code
    listMenu: '/website-boot/menu/listMenu',
    // 2022041907 获取客服联系方式
    getCustomerContact: '/website-boot/admin/sideTool/getCustomerContact',
    // 2022041909 获取下载信息列表
    listDownloadInfo: '/website-boot/admin/sideTool/listDownloadInfo',
    // 标签树
    tagManageTagTree: '/basics-boot/tagManage/tagTree',
    // 根据用户ID判断是否实名
    getAuthorInfo: '/oauth-boot/oauth/getAuthorInfo',
    // 根据域名和appcode获取租户对应网站信息
    getWebsiteByDomainArray: '/website-boot/home/getWebsiteByDomainArray',

    // 菜单列表
    treePlate: '/website-boot/home/treePlate',
    // 获取首页网站配置
    getConfiguration: '/website-boot/home/getConfiguration',
    // 获取具体资源信息
    getWebSiteResource: '/website-boot/home/getWebSiteResource',
    // 板块首页
    page: '/website-boot/home/page',
    // 模块资源列表
    moduleResource: '/website-boot/home/moduleResource',
    // 新建(修改）招生链接关联的字段
    addOrUpdateCfgCustomField: '/basics-boot/column/addOrUpdateCfgCustomField',
    // 删除自定义字段
    deleteCfgCustomField: '/basics-boot/column/deleteCfgCustomField',
    // 招录学生列表的tab
    recruitStudentTag: '/enroll-boot/enroll/recruitStudentTag',
    // 对照
    contrastStuInfo: '/enroll-boot/enroll/contrastStuInfo',
    // 根据招生主表id分页获取招录学生列表
    pageRecruitStudent: '/enroll-boot/enroll/pageRecruitStudent',
    // 根据招募id获取字段列表
    listFieldByRecruitId: '/enroll-boot/enroll/listFieldByRecruitId',
    // 新增（修改）录入学生信息
    addOrUpdateStu: '/enroll-boot/enroll/addOrUpdateStu',
    // 新增（修改）佐证材料
    addOrUpdateEvidence: '/enroll-boot/enroll/addOrUpdateEvidence',
    // 查看录入的学生信息
    getEnrollStuInfo: '/enroll-boot/enroll/getEnrollStuInfo',
    // 分页获取新闻列表
    pageNews: '/website-boot/admin/news/pageNews',
    // 分页获取详细新闻列表
    listNewsType: '/website-boot/admin/news/listNewsType',
    // 获取录入学生信息
    getEnrollInfo: '/enroll-boot/enroll/getEnrollInfo',
    // 提交信息
    saveEnrollInfo: '/enroll-boot/enroll/saveEnrollInfo',
    // 下载文件
    getCustomFileDocument: '/enroll-boot/enroll/getCustomFileDocument',
    // 上传扫描件
    modScanFileId: '/enroll-boot/enroll/modScanFileId',
    // 2022041902 获取功能的开关
    getSwitch: '/website-boot/admin/sideTool/getSwitch',
    //  2022041905 获取客服信息
    getCustomer: '/website-boot/admin/sideTool/getCustomer',
    // 202206211458-根据websiteId获取底部栏配置
    listBeian: '/website-boot/admin/system/listBeian'
  },

  /* token登录 */
  getRecUserTokenDtoByToken: '/oauth-boot/oauth/getRecUserTokenDtoByToken',
  userInfo: {
  /* 查询学校 */
    queryList: '/basics-boot/university/queryList',
    /* 个人信息 */
    getMyUserInfo: '/basics-boot/info/getMyUserInfo',
    /* 修改或新增个人信息 */
    modifyMyUserInfo: '/basics-boot/info/modifyMyUserInfo'
  },
  guide: {
  // 分页获取指导资料列表
    pageDatum: '/match-boot/master/pageDatum'
  },

  // 招聘模块

  invite: {
  // 获取招聘会详情
    getFairInfoById: '/jobs-boot/fair/getFairInfoById',
    // 获取热门职位list 默认6个
    listHotPosition: '/jobs-boot/position/listHotPosition',
    // 2022032109 根据获取与企业沟通的会话id
    getEnterprisesDialogId: '/jobs-boot/enterprises/getEnterprisesDialogId',
    // 获取热门用人单位list
    listHotEnterprise: '/jobs-boot/enterprises/listHotEnterprise',
    // 获取热门招聘会list
    ListHotFair: '/jobs-boot/fair/ListHotFair',

    // 根据配置类型 查询相关数据(最低，最高，几倍薪资)
    listLabelByLabelCode: '/jobs-boot/setting/listLabelByLabelCode',
    // 获取行业树
    treeDictIndustryDto: '/jobs-boot/setting/treeDictIndustryDto',

    // 查询用人单位信息 （有传fairId 按招聘会查询该招聘会下的用人单位，没传查所有用人单位）
    pageEnterprises: '/jobs-boot/enterprises/pageEnterprises',
    // 获取配置权限
    listLabelMaster: '/jobs-boot/setting/listLabelMaster',
    // 查询职位信息 （有传fairId 按招聘会查询该招聘会下的职位，没传查所有职位）
    pagePositionDto: '/jobs-boot/position/pagePositionDto',
    // 获取招聘会用人单位。岗位。人才 总数
    getFairInfoNum: '/jobs-boot/fair/getFairInfoNum',
    // 查询城市
    listSubNormArea: '/basics-boot/area/listSubNormArea',
    // 分页获取(浏览过/已投递/面试/感兴趣/邀我投/收藏我的/看过我的)列表
    pageRelationPosition: '/jobs-boot/jobhunter/pageRelationPosition',
    // 个人职位查询下拉
    listExpectPosition: '/jobs-boot/resumes/listExpectPosition',
    // 获取个人中心右侧 个人基础信息
    getRightUserInfo: '/jobs-boot/resumes/getRightUserInfo',
    // 编辑添加个人信息
    addOrEditJobhunter: '/jobs-boot/resumes/addOrEditJobhunter',
    // 获取招聘会详情
    getJobFairInfo: '/jobs-boot/fair/getJobFairInfo',
    // 获取用人单位详情
    getEnterprises: '/jobs-boot/enterprises/getEnterprisesById',
    // 获取职位详情
    getPositionInfo: '/jobs-boot/position/getPositionById',
    // 添加单个简历并返回列表（单存全取）
    addAttachment: '/fastdfs-boot/resource/addAttachment',
    // 删除单个简历并返回列表（单存全取）
    delAttachment: '/fastdfs-boot/resource/delAttachment',
    // 返回简历列表（单存全取）
    listAttachment: '/fastdfs-boot/resource/listAttachment',
    // 地区查询树接口，默认查三级
    treeArea: '/basics-boot/area/treeArea',
    // 求职者对职位进行操作/用人单位对求职者进行操作 A:投递简历 B：收藏职位 C:用人单位收藏求职者 D:用人单位浏览求职者信息
    operatePosition: '/jobs-boot/jobhunter/operatePosition',
    // 202101231957用人单位招聘会报名列表
    pageEnrollJobFairApproveClient:
    '/jobs-boot/fair/pageEnrollJobFairApproveClient',
    // 202101231606用人单位报名招聘会
    enrollJobFair: '/jobs-boot/enterprises/enrollJobFair',
    // 获取配置权限
    listLabelMaster: '/jobs-boot/setting/listLabelMaster',
    // 202103211145 创建招聘会
    addEnterpriseFair: '/jobs-boot/fair/addEnterpriseFair',
    // 202103211503获取招聘会列表
    pageJobFair: '/jobs-boot/fair/pageJobFair',
    // 根据时间获取活动列表
    fairAndPreach: '/jobs-boot/fair/fairAndPreach',
    // 宣讲会
    pagePreachInfo: '/jobs-boot/preach/pagePreachInfo',
    // 根据规格获取轮播图配置
    listViewPagerByColumn: '/basics-boot/jobviewpager/listViewPagerByColumn',
    // 编辑我的简历是否隐藏
    editJobhunterHide: '/jobs-boot/resumes/editJobhunterHide',
    // 2022092002获取关联的职位列表是否阅读
    relationPositionList: '/jobs-boot/jobhunter/relationPositionList'
  },
  // 学籍
  archive: {
  /* 绑定接口 */
    bindingArchive: '/jobs-boot/archive/bindingArchive',
    /* 获取我的学籍 */
    getMyArchive: '/jobs-boot/archive/getMyArchive',
    /* 提交或者变更 */
    submitOrModify: '/jobs-boot/archive/submitOrModify',
    /* 学生撤回学籍信息*/
    operateMyArchive: '/jobs-boot/archive/operateMyArchive',
    pageJobFair: '/jobs-boot/fair/pageJobFair',
    /* basics 服务的 获取字典list
    archive_categories_difficult_students  困难生类别
    archive_education  学历
    archive_educational_system  学制
    archive_id_card_type  证件类型
    archive_job_category  工作职位类别
    archive_learn_form  学习方式
    archive_nation  民族
    archive_political_outlook  政治面貌
    archive_registration_card_issued  报到证签发类别
    archive_sex  性别
    archive_students_type  师范生类别
    archive_training_mode  培养方式
    archive_Unit industry  单位行业
    archive_unit_nature  单位性质
    archive_professional_counterpart  专业对口情况
    archive_where_graduate  毕业去向 */
    listDictBasicObjByName: '/basics-boot/common/listDictBasicObjByName',
    /* basics 服务的 根据学历类型 获取专业树 三級的 */
    treeProfessional: '/basics-boot/common/treeProfessional',
    /* basics 服务 根据学校id 获取院系下拉框 */
    listRecCollege: '/jobs-boot/user/listSubOrgRelation'
  },
  // 签约
  signed: {
  /* 验证当前用户是否可以进入签约管理界面（用户端） */
    getUserSigned: '/jobs-boot/signed/getUserSigned',
    /* 学生获取自己的签约列表 (前台的) */
    pageSelfSignedAgreementList:
    '/jobs-boot/signed/pageSelfSignedAgreementList',
    /* 获取详情接口根据id */
    getSignedAgreementById: '/jobs-boot/signed/getSignedAgreementById',
    /* 根据id 获取解约协议详情（）就是获取详情接口 */
    getRecSignedAgreementById: '/jobs-boot/signed/getRecSignedAgreementById',
    /* 查看解约详情信息 */
    getTerminationById: '/jobs-boot/signed/getTerminationById',
    /* 同意签约（前台） */
    agreeSignedAgreement: '/jobs-boot/signed/agreeSignedAgreement',
    /* 拒绝签约（前台） */
    noAgreeSignedAgreement: '/jobs-boot/signed/noAgreeSignedAgreement',
    /* 撤回签约（前台） 用户误操作 还原到 待回应列表 */
    withdrawSignedAgreement: '/jobs-boot/signed/withdrawSignedAgreement',
    /* 学生邀请学校认证 签约书 带上自己电子签名 */
    signatureSignedAgreement: '/jobs-boot/signed/signatureSignedAgreement',
    /* 查看协议文件 */
    getSignedAgreement: '/jobs-boot/signed/getSignedAgreement',
    /* 学生获取自己的解约列表（解约数据 很少 不做分页操作了） */
    pageSelfTerminatetList: '/jobs-boot/signed/pageSelfTerminatetList',
    /* 前台学生 线上解约 操作按钮 */
    studentonlineTerminationButton:
    '/jobs-boot/signed/studentonlineTerminationButton',
    /* 学生主动发起解约申请*/
    onlineTerminationStudent: '/jobs-boot/signed/onlineTerminationStudent',
    /* 学生同意解约（需要短信验证）*/
    studentshowPassonlineTermination:
    '/jobs-boot/signed/studentshowPassonlineTermination',
    /* 查询当前用户线下解约的协议（可能是空，如果是空就只返回 用户信息就好）*/
    getOfflineSignedAgreement: '/jobs-boot/signed/getOfflineSignedAgreement',
    /* 发起线下签约*/
    offlineSignedAgreement: '/jobs-boot/signed/offlineSignedAgreement',
    /* 撤回线下签约*/
    backofflineSigned: '/jobs-boot/signed/backofflineSigned',
    /* 前台 线下签约 盖章协议发起审批操作*/
    offlineAgreement: '/jobs-boot/signed/offlineAgreement',
    /* 学生主动发起线下解约申请*/
    offlineTermination: '/jobs-boot/signed/offlineTermination',
    /* 学生撤回线下解约申请*/
    backofflineTermination: '/jobs-boot/signed/backofflineTermination',
    /* 学生主动发起线下解约申请*/
    offlineTermination: '/jobs-boot/signed/offlineTermination'
  },
  jobSent: {
  // 获取行业一级树 按产业进行区分(这是一个二级树)
    listFirstIndustry: '/jobs-boot/common/listFirstIndustry',
    // 获取学校单位
    queryList: '/jobs-boot/user/listParOrgRelation',
    /* 查询学生本人就业派遣状态 */
    getStudentIfSent: '/jobs-boot/jobSent/getStudentIfSent',
    /* 学生保存就业派遣信息 */
    addOrUpdateJobSent: '/jobs-boot/jobSent/addOrUpdateJobSent',
    /* 学生发起上报就业信息上报 */
    studentSentJob: '/jobs-boot/jobSent/studentSentJob',
    /* 学生发起上报就业信息上报 */
    backJobSent: '/jobs-boot/jobSent/backJobSent',
    /* 202112071634 获取档案去向 */
    fileDestination: '/jobs-boot/jobSent/fileDestination',
    /* 202112101757 申请就业改派 */
    applyJobReSent: '/jobs-boot/jobSent/applyJobReSent',
    /* 202112101800 撤回改派申请 */
    callBackReSent: '/jobs-boot/jobSent/callBackReSent',
    /* 202112101811 删除（作废)改派申请 */
    delReSent: '/jobs-boot/jobSent/delReSent',
    /* 获取电子报到证地址 */
    getRegistrationCertificate: '/jobs-boot/jobSent/getRegistrationCertificate'
  },
  companyProduct: {
  // 20220415-产品下拉框反20条
    listAllProductByFuzzySearch: '/oa-boot/product/listAllProductByFuzzySearch',
    // 获取华为订单
    pageHuaWeiOrder: '/order-boot/huaWeiStore/pageHuaWeiOrder',
    // 获取华为订单类型
    listOrderType: '/order-boot/huaWeiStore/listOrderType',
    // 修改订单信息 只是租戶部分
    updateHuaWeiOrder: '/order-boot/huaWeiStore/updateHuaWeiOrder',
    // 提交订单，根據status 提交不同状态
    submitHuaWeiOrder: '/order-boot/huaWeiStore/submitHuaWeiOrder',
    // 获取订单详情
    getHuaWeiOrder: '/order-boot/huaWeiStore/getHuaWeiOrder',
    // 根据订单id 查询日志
    pageReqHuaweiOrder: '/oa-boot/huaWeiStore/pageReqHuaweiOrder',
    // 获取产品分类配置列表
    listProductCategoryConfig: '/oa-boot/product/listProductCategoryConfig',
    // 获取产品分类列表
    listProductCategory: '/oa-boot/product/listProductCategory',
    // 添加和修改产品分类
    addAndUpdateProductCategory: '/oa-boot/product/addAndUpdateProductCategory',
    // 删除产品分类
    delProductCategory: '/oa-boot/product/delProductCategory',
    // 启用关闭产品分类
    onOffProduct: '/oa-boot/product/onOffProduct',
    // 获取产品列表
    pageProduct: '/oa-boot/product/pageProduct',
    // 新增和修改产品
    addAndUpdateProduct: '/oa-boot/product/addAndUpdateProduct',
    // 添加产品价格信息(预生成id)
    addProductPrice: '/oa-boot/product/addProductPrice',
    // 2021120918查看产品详情
    detailProduct: '/oa-boot/product/detailProduct',
    // 2021121010删除产品价格信息
    delProductPrice: '/oa-boot/product/delProductPrice',
    // 删除产品
    delProduct: '/oa-boot/product/delProduct',
    // 上架、下架和撤回
    productOperate: '/oa-boot/businessRelation/website/productOperate'
  },
  // 沟通管理
  communicate: {
  // 分页
    pageProductUserImGroup: '/message-boot/message/im/pageProductUserImGroup',
    // 关注
    modConcernFlag: '/message-boot/message/im/modConcernFlag',
    // 电话回访分页
    pageCallBack: '/message-boot/message/callBack/pageCallBack',
    // 电话的回访添加和编辑
    addOrEditCallBack: '/message-boot//message/callBack/addOrEditCallBack',
    // 删除
    delCallBack: '/message-boot/message/callBack/delCallBack'
  },
  // 证书
  certificate: {
  // 证书查询
    listMyCertificate: '/classroom-boot/certificate/listMyCertificate',
    // 证书展示分页
    pageAllMyCertificate: '/classroom-boot/certificate/pageAllMyCertificate',
    // 下载证书
    downloadCertificate: '/classroom-boot/certificate/downloadCertificate'
  },
  product: {
  // 202208041428-产品上架分类数据集
    listPutawayClassifyData: '/oa-boot/product/home/listPutawayClassifyData',
    // 2022080315184-home产品分页
    homePageProduct: '/oa-boot/product/home/pageProduct',
    // 202208041018-home产品详情
    getHomeProductById: '/oa-boot/product/home/getHomeProductById',
    // 202208041112-根据业务id+type获取合作案例分页(审批通过的数据)
    pageByBusinessIdAndType: '/oa-boot/cooperationCase/pageByBusinessIdAndType',
    // 合作案例详情
    getCooperationCase: '/oa-boot/cooperationCase/getCooperationCase',
    // 202208051114-相关案例
    listCorrelationCooperationCase:
    '/oa-boot/cooperationCase/listCorrelationCooperationCase',
    // 分页
    pageProduct: '/oa-boot/product/website/pageProduct',
    // 202208230853获取
    getResourceIdsApplicationCase:
    '/website-boot/admin/resource/getResourceIds',
    // 获取
    listApplicationCase: '/oa-boot/cooperationCase/listApplicationCase'
  },
  // 服务
  massage: {
  // 合作案例分页
    pageCooperationCase: '/oa-boot/cooperationCase/pageCooperationCase',
    // 合作案例增加/修改
    addOrEditCooperationCase:
    '/oa-boot/cooperationCase/addOrEditCooperationCase',
    // 合作案例 删除
    delCooperationCase: '/oa-boot/cooperationCase/delCooperationCase',
    // 合作案例 审批、撤回、重新发起
    operateCooperationCase: '/oa-boot/cooperationCase/operateCooperationCase'
  },
  // 评价管理
  evaluates: {
  // 202207291818-前台评论分页 (审批通过的)
    pageComment: '/basics-boot//comment/door/pageComment'
  },
  // 未入驻
  settleIn: {
    checkUserEnterStatus: '/oauth-boot/enter/checkUserEnterStatus'
  },
  /** 简历 */
  resume: {
  // 获取当前登陆人的所有简历信息（有主键id 拿主键id 查询，没有就拿当前登录人id 查询到主键id）
    getAllResumes: '/jobs-boot/resumes/getAllResumes',
    // 新增、修改求职者基本信息
    addOrEditJobhunte: '/jobs-boot/resumes/addOrEditJobhunter',
    // 新增、修改个人期望岗位基本信息
    addOrEditExpectPosition: '/jobs-boot/resumes/addOrEditExpectPosition',
    // 删除个人期望岗位基本信息
    delExpectPosition: '/jobs-boot/resumes/delExpectPosition',
    // 新增、修改个人工作经历基本信息
    addOrEditWorkExperience: '/jobs-boot/resumes/addOrEditWorkExperience',
    // 删除个人工作经历基本信息
    delWorkExperience: '/jobs-boot/resumes/delWorkExperience',
    // 新增、修改项目经历基本信息
    addOrEditProjectExperience: '/jobs-boot/resumes/addOrEditProjectExperience',
    // 删除项目经历基本信息
    delProjectExperience: '/jobs-boot/resumes/delProjectExperience',
    // 新增、修改教育经历基本信息
    addOrEditEducationExperience:
    '/jobs-boot/resumes/addOrEditEducationExperience',
    // 删除项目经历基本信息
    delEducationExperience: '/jobs-boot/resumes/delEducationExperience',
    // 获取配置权限
    listLabelMaster: '/jobs-boot/setting/listLabelMaster',
    // 查询城市
    listSubNormArea: '/basics-boot/area/listSubNormArea',
    // 获取职位类型树
    treeDictPositionTypeDto: '/jobs-boot/setting/treeDictPositionTypeDto',
    // 根据职业类型 获取技能树
    treeDictPositionSkillDto: '/jobs-boot/setting/treeDictPositionSkillDto',
    // 根据配置类型 查询相关数据
    listLabelByLabelCode: '/jobs-boot/setting/listLabelByLabelCode',
    // 获取行业树
    treeDictIndustryDto: '/jobs-boot/setting/treeDictIndustryDto',
    // 新增、修改证书基本信息
    addOrEditCertificate: '/jobs-boot/resumes/addOrEditCertificate',
    // 删除
    delCertificate: '/jobs-boot/resumes/delCertificate',
    // 根据证书基本信息
    getCertificateById: '/jobs-boot/resumes/getCertificateById'
  },

  // 立项
  projectCreat: {
  // 修改任务权重
    updateTaskProportion: '/oa-boot/task/v3/updateTaskProportion',
    // 获得所有顶级部门
    listTopSysDepartment: '/basics-boot/business/listTopSysDepartment',
    pageProject: '/oa-boot/project/pageProject',
    // 创建立项草稿
    draftProject: '/oa-boot/project/draftProject',
    // 立项指标列表
    listProjectIndex: '/oa-boot/project/listProjectIndex',
    // 添加编辑立项指标
    addOrEditProjectIndex: '/oa-boot/project/addOrEditProjectIndex',
    // 删除立项指标
    delProjectIndex: '/oa-boot/project/delProjectIndex',
    // 移除立项
    deleteProject: '/oa-boot/project/deleteProject',
    // 立项预算列表
    listProjectBudget: '/oa-boot/project/listProjectBudget',
    // 添加修改立项预算
    addOrEditProjectBudget: '/oa-boot/project/addOrEditProjectBudget',
    // 删除预算
    delProjectBudget: '/oa-boot/project/delProjectBudget',
    // 编辑立项
    addOrEditProject: '/oa-boot/project/addOrEditProject',
    // 获取立项详情
    getProject: '/oa-boot/project/getProject',
    // 撤回立项
    returnBack: '/oa-boot/project/returnBack',
    // 重新发起
    republish: '/oa-boot/project/republish',
    // 发起验收
    launchAcceptance: '/oa-boot/project/launchAcceptance',
    // 验收
    doAcceptance: '/oa-boot/common/doAcceptance',
    // 立项列表
    listProject: '/oa-boot/project/listProject',
    // 获取年计划细项列表
    listYearPlanDetail: '/oa-boot/yearPlan/listYearPlanDetail',
    listYearPlanDetailTitle: '/oa-boot/yearPlan/listYearPlanDetailTitle',
    // 添加阶段接口
    addOrEditPhases: '/oa-boot/phases/addOrEditPhases',
    // 删除阶段接口
    delPhases: '/oa-boot/phases/delPhases',
    // 添加或者编辑成员 接口
    addOrEditProjectRelation:
    '/oa-boot/businessRelation/addOrEditProjectRelation',
    // 删除成员接口
    delRelation: '/oa-boot/businessRelation/delRelation',
    // 获取所属项目阶段
    listProjectAndPhase: '/oa-boot/project/listProjectAndPhase',
    // 修改项目实际周期
    editProjectActualCycle: '/oa-boot/project/editProjectActualCycle',
    // 获取每个阶段下的任务列表，不传projectPhasesId表示查全部阶段
    pageTaskByProjectPhase: '/oa-boot/task/v2/pageTaskByProjectPhase',
    // 获取剩余项目占比
    getAllocatedProjectPercent:
    '/oa-boot/month/plan/getAllocatedProjectPercent',
    // 保存阶段排序
    saveSortPhases: '/oa-boot/phases/saveSortPhases',
    // 添加客户到项目中
    addOrEditProjectCustomer: '/oa-boot/project/addOrEditProjectCustomer',
    // 从立项中 删除客户
    delProjectCustomer: '/oa-boot/project/delProjectCustomer',
    // 查询客户list
    listProjectCustomer: '/oa-boot/project/listProjectCustomer',
    // 202110010019---项目客户列表
    listCustomer: '/oa-boot/project/V2/listProjectCustomer',
    // 202110010012---增加项目客户
    addCustomer: '/oa-boot/project/V2/addProjectCustomer',
    // 202110010014---删除项目客户 (真删)
    delProjectCustomerV2: '/oa-boot/project/V2/delProjectCustomer',
    // 202110010020---项目预算列表
    listProjectBudgetV2: '/oa-boot/project/V2/listProjectBudget',
    // 202110010042--创建、编辑项目测算
    addOrEditProjectBudgetV2: '/oa-boot/project/V2/addOrEditProjectBudget',
    // 202110010111--删除项目测算（真删）
    delProjectBudgetV2: '/oa-boot/project/V2/delProjectBudget',
    // 202110011350---项目成员列表
    listProjectMember: '/oa-boot/project/V2/listProjectMember',
    // 202110011334--创建、编辑项目成员
    addOrEditProjectMember: '/oa-boot/project/V2/addOrEditProjectMember',
    // 202110011338--删除项目成员（真删）
    delProjectMember: '/oa-boot/project/V2/delProjectMember',
    // 202110081437---数值化目标列表
    listProjectTarget: '/oa-boot/project/V2/listProjectTarget',
    // 202110081416---编辑数值化目标
    editProjectTarget: '/oa-boot/project/V2/editProjectTarget',
    // 202110031106 创建/编辑任务
    saveTask: '/oa-boot/task/v3/saveTask',
    // 202110031146 获取任务列表
    listTask: '/oa-boot/task/v3/listTask',
    // 202110031152 获取任务详情
    getTask: '/oa-boot/task/v3/getTask',
    // 202110031158 删除任务
    delTask: '/oa-boot/task/v3/delTask',
    // 202110031201 复制任务
    copyTask: '/oa-boot/task/v3/copyTask',
    // 202110040025--查看立项主表信息（id为空返回草稿）
    getProjectV2: '/oa-boot/project/V2/getProject',
    // 202109301451--创建/编辑项目
    addOrEditProjectV2: '/oa-boot/project/V2/addOrEditProject',
    // 获取产品list
    listProductList: '/basics-boot/System/listProductList',
    // 202110111549 获取指标类型
    listTargetType: '/oa-boot/task/v3/listTargetType',
    // 202110071512 获取某立项任务的指标列表
    listTarget: '/oa-boot/task/v3/listTarget',
    // 202110111543 新增/修改任务考核指标
    addOrModTaskTarget: '/oa-boot/task/v3/addOrModTarget',
    // 202010111547 删除考核标准
    delTarget: '/oa-boot/task/v3/delTarget',
    // 202110071425 获取项目的指标汇总
    getProjectTargetSummary: '/oa-boot/task/v3/getProjectTargetSummary',
    // 202110071656 分页获取项目的任务列表
    pageTask: '/oa-boot/task/v3/pageTask',
    // 202110040059--修改项目归属
    affiliationProject: '/oa-boot/project/V2/affiliationProject',
    // 202110081536---获取项目人员列表
    projectAllPersonnel: '/oa-boot/project/V2/projectAllPersonnel',
    // 202110071554 获取某天指标进展
    getCurrentDayTaskProgress: '/oa-boot/task/v3/getCurrentDayTaskProgress',
    // 202110071629 新增/编辑某天指标进展（同时计算任务的最终值）
    addOrModTaskProgress: '/oa-boot/task/v3/addOrModTaskProgress',
    // 202110161657 切换任务指标模板
    switchTargetTemplate: '/oa-boot/task/v3/switchTargetTemplate',
    // 获取模板
    performanceTemplate: '/oa-boot/performanceSetting/libTemplate/list',
    // 获取剩余绩效分
    personCurrentMonthRemainingPerformance:
    '/oa-boot/task/v3/personCurrentMonthRemainingPerformance',
    // // 排序任务
    // sortTask: '/oa-boot/task/v3/sortTask',
    // 父子排序任务
    sortTask: '/oa-boot/task/v3/sortTaskV2',
    // 任务修改所属项目列表
    pageAffiliationProject: '/oa-boot/project/V2/pageAffiliationProject',
    // 任务修改所属项目
    updateTaskAffiliation: '/oa-boot/task/v3/updateTaskAffiliation',
    // 获取客户下拉数据
    fuzzySearchCustomer: '/oa-boot/customer/v2/fuzzySearchCustomer',
    // 202111231获取下拉框标签数据
    combByBusinessId: '/oa-boot/label/combByBusinessId',
    // 202111232添加标签
    addBusinessLabel: '/oa-boot/label/addBusinessLabel',
    // 202111233删除标签
    delBusinessLabel: '/oa-boot/label/delBusinessLabel',
    // 202111234获取已添加标签数据
    listByBusinessId: '/oa-boot/label/listByBusinessId',
    // 202202091725-项目月份指标List
    listMonthTargets: '/oa-boot/project/V2/listMonthTargets',
    // 202202091720--项目月份指标新增Or修改
    addOrEditMonthTargets: '/oa-boot/project/V2/addOrEditMonthTargets'
  },
  fastdfs: {
  // 添加单个附件并返回列表（单存全取）
    addAttachment: '/fastdfs-boot/resource/addAttachment',
    // 删除单个附件并返回列表（单存全取）
    delAttachment: '/fastdfs-boot/resource/delAttachment',
    // 返回附件列表（单存全取）
    listAttachment: '/fastdfs-boot/resource/listAttachment',
    // 新通用文件列表
    listCustomerAttachment: '/oa-boot/customer/v3/listCustomerAttachment',
    // 客户往来文件列表分页
    pageAttachment: '/oa-boot/file/pageAttachment'
  },
  // 立项（新）
  projectCreatNew: {
  // 删除 审批相关项目
    delProjectApprove: '/oa-boot/approve/delProjectApprove',
    // 立项关联审批列表接口
    listProjectApprove: '/oa-boot/approve/listProjectApprove',
    // 删除绩效
    delPersonMonthTask: '/oa-boot/project/V2/delPersonMonthTask',
    // 获取项目分类
    treeProjectClassify: '/oa-boot/projectClassify/treeProjectClassify',
    // 202202242056-获取分类年份下拉框
    projectClassifyYearList: '/oa-boot/projectClassify/projectClassifyYearList',
    // 202203011617-指标报表关联的项目(按人员查看）
    listProjectIndexReportUser:
    '/oa-boot/projectClassify/listProjectIndexReportUser',
    // 2022003011515-指标报表(按个人看)
    listProjectByClassifyUserId:
    '/oa-boot/projectClassify/listProjectByClassifyUserId',
    // 202202281702-指标报表关联的项目
    listProjectByClassifyId: '/oa-boot/projectClassify/listProjectByClassifyId',
    // 202202281544-指标报表(分类)
    listProjectIndexReport: '/oa-boot/projectClassify/listProjectIndexReport',
    // 202202251156-分类指标分解List(人员)
    listUserClassifyTarget: '/oa-boot/projectClassify/listUserClassifyTarget',
    // 202202251006-添加指标目标值(按人员指标分解)
    addUserClassifyValue: '/oa-boot/projectClassify/addUserClassifyValue',
    // 202202281139-删除指标分解List(人员)
    delUserClassifyTarget: '/oa-boot/projectClassify/delUserClassifyTarget',
    // 202202242053-根据年份获取树型分类
    treeByPermissionGroup: '/oa-boot/projectClassify/treeByPermissionGroup',
    // 202202242050-增加/编辑分类
    addOrEditProjectClassify:
    '/oa-boot/projectClassify/addOrEditProjectClassify',
    // 202202251706-根据id获取分类
    getProjectClassify: '/oa-boot/projectClassify/getProjectClassify',
    // 202202250956-分类指标分解List
    listClassifyTarget: '/oa-boot/projectClassify/listClassifyTarget',
    // 202202250955-添加指标目标值(分类指标分解)
    addClassifyValue: '/oa-boot/projectClassify/addClassifyValue',
    // 202202242101-删除分类
    delProjectClassify: '/oa-boot/projectClassify/delProjectClassify',
    // 202111060952-获取当月日志得分
    findMonthByUserId: '/oa-boot/homePage/findMonthByUserId',
    // 获取验收全部任务
    listAllTaskByMonth: '/oa-boot/task/V3/listAllTaskByMonth',
    // 查询所有部门列表 分装好的
    listDictDepartment: '/basics-boot/System/listDictDepartment',
    // 202110281408--验收批量审批，发起
    batchOperation: '/oa-boot/project/V2/batchOperation',
    // 立项列表标星
    asteriskProject: '/oa-boot/project/V2/asteriskProject',
    // 20211118 分页获取评论接口（根据业务id、类型、动态，默认倒序）
    pageComments: '/message-boot/message/comment/pageComments',
    // 项目归档操作
    updatePigeonholeFlag: '/oa-boot/project/V2/updatePigeonholeFlag',
    // 个人绩效项目下拉框
    listProjectByPersonTask: '/oa-boot/project/V2/listProjectByPersonTask',
    // 202111060944-立项动态指标累计
    sumPageProject: '/oa-boot/project/V2/sumPageProject',
    // 202111060952-绩效个人动态指标累计
    sumPagePersonMonthTask: '/oa-boot/project/V2/sumPagePersonMonthTask',
    // 202111060952-绩效部门动态指标累计
    sumDepartmentMonthTask: '/oa-boot/project/V2/sumDepartmentMonthTask',
    // 202112061531-增加修改奖惩
    addOrEditRewardsPunishment:
    '/oa-boot/rewardsPunishment/addOrEditRewardsPunishment',
    // 202112061800-删除奖惩
    delRewardsPunishment: '/oa-boot/rewardsPunishment/delRewardsPunishment',
    // 202112061849-获取单条奖惩
    getRewardsPunishment: '/oa-boot/rewardsPunishment/getRewardsPunishment',
    // 202112061531-奖惩分页
    pageRewardsPunishment: '/oa-boot/rewardsPunishment/pageRewardsPunishment',
    // 202112061931-某人某年某月的奖惩情况
    monthRewardsPunishment: '/oa-boot/rewardsPunishment/monthRewardsPunishment',
    // 指标显示开关
    updateShowFlag: '/oa-boot/performanceSetting/target/updateShowFlag',
    // 202110201146--根据部门分页获取人员指标占比配置信息
    pageIndividualIndicators: '/oa-boot/project/V2/pageIndividualIndicators',
    // 年份搜索下拉框
    getYear: '/oa-boot/project/V2/getYear',
    // 202110201146--根据部门分页获取人员指标占比配置信息
    copyProject: '/oa-boot/project/V2/copyProject',
    // 2021102117233--修改绩效分
    updatePerformancePercent: '/oa-boot/task/v3/updatePerformancePercent',
    // 202110211422--获取日志考勤等信息
    getLogOrCheckingIn: '/oa-boot/project/V2/getLogOrCheckingIn',
    // 202110151357 --获取某年某月的个人任务
    getPersonTask: '/oa-boot/project/V2/getPersonTask',
    // 202110201146--根据部门分页获取人员指标占比配置信息
    addIndividualIndicators: '/oa-boot/project/V2/addIndividualIndicators',
    // 202110201357 --删除个人指标占比分类
    delIndividualIndicators: '/oa-boot/project/V2/delIndividualIndicators',
    // 202110201351--查看个人指标占比分类
    getIndividualIndicators: '/oa-boot/project/V2/getIndividualIndicators',
    // 202110151835--分页验收人
    pageCheckPerson: '/oa-boot/project/V2/pageCheckPerson',
    // 202110190922 --- 删除验收人
    delCheckPerson: '/oa-boot/project/V2/delCheckPerson',
    // 认定人开关
    updateCognizanceFlag: '/oa-boot/project/V2/updateCognizanceFlag',
    // 202110151809--增加验收人
    addCheckPerson: '/oa-boot/project/V2/addCheckPerson',
    // 202110190920--查看验收人详情
    getCheckPerson: '/oa-boot/project/V2/getCheckPerson',
    // 202110151605--分页获取考核时间点
    pageCheckTime: '/oa-boot/project/V2/pageCheckTime',
    // 202110151626--增加Or修改考核时间点
    addOrEditCheckTime: '/oa-boot/project/V2/addOrEditCheckTime',
    // 202110151623--删除考核时间点（逻辑删除）
    delCheckTime: '/oa-boot/project/V2/delCheckTime',
    // 202110040135--分页获取项目管理
    pageProject: '/oa-boot/project/V2/pageProject',
    // 202110040135--分页获取项目管理
    delProject: '/oa-boot/project/V2/delProject',
    // 202110150946--发布项目
    publishProject: '/oa-boot/project/V2/publishProject',
    // 202110141532--个人绩效分页
    pagePersonMonthTask: '/oa-boot/project/V2/pagePersonMonthTask',
    // 202110141532--部门绩效分页
    pageDepartmentMonthTask: '/oa-boot/project/V2/pageDepartmentMonthTask',
    // 202110141745 获取指标分类列表
    list: '/oa-boot/performanceSetting/targetType/list',
    // 202110151050 分页获取库存指标列表
    pageTarget: '/oa-boot/performanceSetting/target/pageTarget',
    // 202110151044 查看指标详情
    getTarget: '/oa-boot/performanceSetting/target/getTarget',
    // 202110151036  新增/修改库存指标
    addOrModTarget: '/oa-boot/performanceSetting/target/addOrModTarget',
    // 202110151053 删除指标
    delTarget: '/oa-boot/performanceSetting/target/delTarget',
    // 202110141557 禁用/启用指标分类
    enableTargetType: '/oa-boot/performanceSetting/targetType/enableTargetType',
    // 202110141752 新增/修改指标分类
    addOrModTargetType:
    '/oa-boot/performanceSetting/targetType/addOrModTargetType',
    // 202110141753 删除指标分类
    delTargetType: '/oa-boot/performanceSetting/targetType/delTargetType',
    // sortTargetType
    sortTargetType: '/oa-boot/performanceSetting/targetType/sortTargetType',
    // 202110151915 分页获取模板列表
    libTemplatePage: '/oa-boot/performanceSetting/libTemplate/page',
    // 202010151544 获取考核模板
    getTemplate: '/oa-boot/performanceSetting/libTemplate/getTemplate',
    // 202110151908 新增/编辑模板
    addOrModTemplateLib:
    '/oa-boot/performanceSetting/libTemplate/addOrModTemplateLib',
    // 202110151928 获取模板库的指标
    listTemplateTarget:
    '/oa-boot/performanceSetting/libTemplate/listTemplateTarget',
    // 202110151911 复制模板
    copyTemplate: '/oa-boot/performanceSetting/libTemplate/copy',
    // 202110151913 删除模板
    delTemplate: '/oa-boot/performanceSetting/libTemplate/delTemplate',
    // 202110151926 删除模板指标
    delTemplateTarget:
    '/oa-boot/performanceSetting/libTemplate/delTemplateTarget',
    // addOrModTemplateTarget 新增/修改模板指标
    addOrModTemplateTarget:
    '/oa-boot/performanceSetting/libTemplate/addOrModTemplateTarget',
    // 202110211337 分页获取部门下的任务
    pageAcceptanceTask: '/oa-boot/task/v3/pageAcceptanceTask',
    // 202110211408 待验收任务下的考核指标
    listAcceptanceTaskTarget: '/oa-boot/task/v3/listAcceptanceTaskTarget',
    // 202110211 验收人认定指标值
    checkTarget: '/oa-boot/task/v3/checkTarget',
    // 20211021 引用审批信息
    importRelation: '/oa-boot/businessRelation/importRelation',
    // 202111171435--获取人员列表
    listPermissionPersonnel: '/oa-boot/permission/listPermissionPersonnel',
    // 202111172056-获取权限菜单
    permissionMenu: '/oa-boot/permission/permissionMenu',
    // 202111171617--修改权限(勾选，去除)
    modPermission: '/oa-boot/permission/modPermission',
    // 202111172158 --获取个人权限
    getPermission: '/oa-boot/permission/getPermission',
    // 202111221610--批量设置任务的项目权重
    batchSetProjectProportion: '/oa-boot/task/v3/batchSetProjectProportion',
    // 202111221944-任务下的协同
    pageTaskMistake: '/oa-boot/mistake/pageTaskMistake',
    // 删除任务下的协同列表
    delMistake: '/oa-boot//mistake/delMistake',
    // 2021122201 修改协同所属任务
    modMistakeTask: '/oa-boot//mistake/modMistakeTask',
    // 202111231355--项目下的所有顶级任务
    listParentTask: '/oa-boot/task/v3/listParentTask',
    // 获取任务负责人
    listAllUserByProjectId: '/oa-boot/task/v3/listAllUserByProjectId',
    // 修改笔记
    updateTaskRemark: '/oa-boot/task/v3/updateTaskRemark',
    // 获取项目指标列表
    pageMonthProject: '/oa-boot/project/V2/pageMonthProject',
    // 月绩效任务-用于下绩效、查看绩效进度
    pageMonthPerfProjectCollect:
    '/oa-boot/project/V2/pageMonthPerfProjectCollect',
    // 月绩效项目查看下的个人任务
    listTaskByProject: '/oa-boot/task/v3/listTaskByProject'
  },
  exam: {
  /* 202105131644 获取我可以考试的列表*/
    pageMyOwnExam: '/classroom-boot/exam/pageMyOwnExam',
    /* 202205201718 进入考试*/
    enterExam: '/classroom-boot/exam/enterExam',
    /* 202205131437 获取试卷题目索引列表*/
    listExamTopicIndex: '/classroom-boot/exam/listExamTopicIndex',
    /* 202205230920 获取学生单个题目,不包含自己的答案*/
    getStuTopicDetailNotContainAnswer:
    '/classroom-boot/exam/getStuTopicDetailNotContainAnswer',
    /* 202206021449 获取题目我的回答数组*/
    listStuTopicAnswer: '/classroom-boot/exam/listStuTopicAnswer',
    /* 202205200859 回答问题*/
    answerQuestion: '/classroom-boot/exam/answerQuestion',
    /* 202205131527  标记题目*/
    collectTopic: '/classroom-boot/exam/collectTopic',
    /* 202205171026 提交试卷*/
    submitExam: '/classroom-boot/exam/submitExam',
    /* 202205241045 获取考试记录*/
    listExamRecord: '/classroom-boot/exam/listExamRecord',
    /* 202206021449 获取题目的正确回答数组*/
    listTopicCorrect: '/classroom-boot/exam/listTopicCorrect',
    /* // 202206141448-获取课程下的授课教师List*/
    listCoursesTeacherInfo:
    '/classroom-boot/courseCenter/listCoursesTeacherInfo',
    /* 202207251612-考试过程切屏记录*/
    pyScape: '/classroom-boot/exam/pyScape',
    /* 202207251611-心跳模式检查考试情况*/
    detection: '/classroom-boot/exam/detection'
  },
  // 课程评价
  evaluate: {
  // 202206141625-学生评价课程
    addOrModCoursesComment:
    '/classroom-boot/courseCenter/addOrModCoursesComment',
    // 202206141751-课程评论分页(学生+老师页面查看)
    pageCoursesComment: '/classroom-boot/courseCenter/pageCoursesComment',
    // 202206141635-获取学生本人的评价
    getSelfCoursesComment: '/classroom-boot/courseCenter/getSelfCoursesComment'
  },
  // 意见反馈
  feedback: {
  // 2020080402意见反馈
    addFeedback: '/jobs-boot/feedback/addFeedback',
    // 2020080401分页获取意见反馈列表/获取全部意见反馈数据
    pageFeedback: '/jobs-boot/feedback/pageFeedback'
  },
  // 测评问卷
  questionnaires: {
    // 202211071008获取测评记录列表（移动端）
    pageEvaluationRecord: '/enroll-boot/questionnaires/pageEvaluationRecord',
    // 202211291002-创建测评码
    evaluatingCodeCreate: '/enroll-boot/evaluating/evaluatingCodeCreate',
    // 202208131809获取问卷详情
    previewRecTestMainDetail:
    '/enroll-boot/questionnaires/previewRecTestMainDetail',
    // 20220812开始问卷调查
    startTestMian: '/enroll-boot/questionnaires/startTestMian',
    // 20220813016612获取问卷题目详情并返回 上下题目id
    upOrDownTopic: '/enroll-boot/questionnaires/upOrDownTopic',
    // 202208121629回答问题
    answerQuestion: '/enroll-boot/questionnaires/answerQuestion',
    // 202208121638最后提交评测问卷
    submitTestMian: '/enroll-boot/questionnaires/submitTestMian',

    // 202208151524获取评测问卷结果列表
    listEvaluationAnalysis:
    '/enroll-boot/questionnaires/listEvaluationAnalysis',
    // 202208261628个人中心获取自己的作答记录
    pagePersonalAnswerRecord:
    '/enroll-boot/questionnaires/pagePersonalAnswerRecord',
    // 202209081601-根据网站id和资源类型获取资源id
    getResourceIdsByResourceType: '/website-boot/admin/resource/getResourceIdsByResourceType',
    // 202208131139分页获取评测问卷
    pageRecTestMian: '/enroll-boot/questionnaires/pageRecTestMian',
    // 202208131040获取测评分类树
    treeRecTestMainClassify: '/enroll-boot/questionnaires/treeRecTestMainClassify',
    //  202210311354-获取报告
    getReportUrl: '/enroll-boot/evaluating/getReportUrl',
    // 获取测评版本信息列表-202211290959
    pageEvaluationVersion: '/enroll-boot/evaluating/pageEvaluationVersion'
  },
  membership: {
  // 202209142015通过信息id获取入驻信息
    getSettlementInfo: '/basics-boot/settlement/getSettlementInfo',
    // 获取入驻表单配置
    listSettlementConfig: '/basics-boot/settlement/listSettlementConfig',
    // 申请信息暂存
    applyMessageStaging: '/basics-boot/memberManagement/applyMessageStaging',
    // 202209141941添加入驻信息
    addOrModifySettlementInfo: '/basics-boot/settlement/addOrModifySettlementInfo',
    // 202209141349申请进度列表查询
    listApplyMessage: '/basics-boot/memberManagement/listApplyMessage',
    // 202209141349获取全局参数
    getSettlementGlobal: '/basics-boot/settlement/getSettlementGlobal',
    // 202209141050 缴费记录查询
    listPayMessage: '/basics-boot/memberManagement/listPayMessage',
    // 202209151549用户入驻列表
    listSettlementInfo: '/basics-boot/settlement/listSettlementInfo',
    // 202209201130扫一扫跳转路径
    getSettlementSelectingUrl: '/basics-boot/settlement/getSettlementSelectingUrl',
    // 202209201130删除测回入会信息
    delApplyMessage: '/basics-boot/memberManagement/delApplyMessage',
    // 202209201130获取入驻表单配置
    listSettlementSetting: '/basics-boot/settlement/listSettlementSetting',
    // 202209201130获取文件
    getRichText: '/basics-boot/richText/get',
    // 202209201130续期申请
    renewalApplication: '/basics-boot/settlement/renewalApplication',
    // 202209201130撤回申请
    reCallSettlementInfo: '/basics-boot/settlement/reCallSettlementInfo'

  },
  //  产品管理
  companyProduct: {
    // 20220415-产品下拉框反20条
    listAllProductByFuzzySearch: '/oa-boot/product/listAllProductByFuzzySearch',
    // 获取华为订单
    pageHuaWeiOrder: '/order-boot/huaWeiStore/pageHuaWeiOrder',
    // 获取华为订单类型
    listOrderType: '/order-boot/huaWeiStore/listOrderType',
    // 修改订单信息 只是租戶部分
    updateHuaWeiOrder: '/order-boot/huaWeiStore/updateHuaWeiOrder',
    // 提交订单，根據status 提交不同状态
    submitHuaWeiOrder: '/order-boot/huaWeiStore/submitHuaWeiOrder',
    // 获取订单详情
    getHuaWeiOrder: '/order-boot/huaWeiStore/getHuaWeiOrder',
    // 根据订单id 查询日志
    pageReqHuaweiOrder: '/order-boot/huaWeiStore/pageReqHuaweiOrder',
    // 获取产品分类配置列表
    listProductCategoryConfig: '/oa-boot/product/listProductCategoryConfig',
    // 获取产品分类列表
    listProductCategory: '/oa-boot/product/listProductCategory',
    // 添加和修改产品分类
    addAndUpdateProductCategory: '/oa-boot/product/addAndUpdateProductCategory',
    // 删除产品分类
    delProductCategory: '/oa-boot/product/delProductCategory',
    // 启用关闭产品分类
    onOffProduct: '/oa-boot/product/onOffProduct',
    // 获取产品列表
    pageProduct: '/oa-boot/product/pageProduct',
    // 新增和修改产品
    addAndUpdateProduct: '/oa-boot/product/addAndUpdateProduct',
    // 添加产品价格信息(预生成id)
    addProductPrice: '/oa-boot/product/addProductPrice',
    // 2021120918查看产品详情
    detailProduct: '/oa-boot/product/detailProduct',
    // 2021121010删除产品价格信息
    delProductPrice: '/oa-boot/product/delProductPrice',
    // 删除产品
    delProduct: '/oa-boot/product/delProduct',
    // 拖拽产品分类修改父子级和排序
    sortProductCategory: '/oa-boot/product/sortProductCategory',
    // 获取产品列表(已审核)
    pageProduct2: '/oa-boot/product/pageProduct2'
  },
  // 自定义建站

  customWeb: {
    // 202205171539-获取有勾选的菜单Code
    listMenu: '/website-boot/menu/listMenu',
    // 根据域名和appcode获取租户对应网站信息
    getWebsiteByDomainArray: '/website-boot/home/getWebsiteByDomainArray',

    // 菜单列表
    treePlate: '/website-boot/home/treePlate',
    // 获取首页网站配置
    getConfiguration: '/website-boot/home/getConfiguration',
    // 获取具体资源信息
    getWebSiteResource: '/website-boot/home/getWebSiteResource',
    // 板块首页
    page: '/website-boot/home/page',
    // 模块资源列表
    moduleResource: '/website-boot/home/moduleResource',
    // 新建(修改）招生链接关联的字段
    addOrUpdateCfgCustomField: '/basics-boot/column/addOrUpdateCfgCustomField',
    // 删除自定义字段
    deleteCfgCustomField: '/basics-boot/column/deleteCfgCustomField',
    // 招录学生列表的tab
    recruitStudentTag: '/enroll-boot/enroll/recruitStudentTag',
    // 对照
    contrastStuInfo: '/enroll-boot/enroll/contrastStuInfo',
    // 根据招生主表id分页获取招录学生列表
    pageRecruitStudent: '/enroll-boot/enroll/pageRecruitStudent',
    // 根据招募id获取字段列表
    listFieldByRecruitId: '/enroll-boot/enroll/listFieldByRecruitId',
    // 新增（修改）录入学生信息
    addOrUpdateStu: '/enroll-boot/enroll/addOrUpdateStu',
    // 新增（修改）佐证材料
    addOrUpdateEvidence: '/enroll-boot/enroll/addOrUpdateEvidence',
    // 查看录入的学生信息
    getEnrollStuInfo: '/enroll-boot/enroll/getEnrollStuInfo',
    // 分页获取新闻列表
    pageNews: '/website-boot/admin/news/pageNews',
    // 分页获取详细新闻列表
    listNewsType: '/website-boot/admin/news/listNewsType'
  },
  /* 前台 */
  webapp: {
    /* 用户 */
    user: {
      // 找回密码
      findPwd: '/oauth-boot/oauth/findPwd',
      // 用户注册
      register: '/oauth-boot/oauth/register',
      // 用户登录
      login: '/oauth-boot/oauth/login',
      // 用户注销
      logout: '/oauth-boot/oauth/logout',
      // 修改密码
      modifyPwd: '/oauth-boot/oauth/modifyPwd',

      updatePersonInfo: '/oa-boot/homePage/updatePersonInfo'

    }

  },

  /* 后台 */
  admin: {
    /* home */
    home: {
      // 根据赛道id，等级id，管理id，获取届别
      getSessionIndex: '/match-boot/homepage/getSessionIndex',
      // 获取赛事列表
      getEventList: '/match-boot/homepage/eventList'
    }
  },
  enter: {
    getMyEnter: '/oauth-boot/enter/getMyEnter',
    submitEnter: '/oauth-boot/enter/submitEnter',
    checkUserIsEnter: '/oauth-boot/enter/checkUserEnterStatus',
    getEnterInfoById: '/oauth-boot/enter/getEnterInfoById',
    modifyEnterStatus: '/oauth-boot/enter/modifyEnterStatus',
    // 20210120012800 获取教师承诺书下载地址

    listSettlementInfo: '/basics-boot/settlement/listSettlementInfo',
    getSystemConfig: '/basics-boot/info/getSystemConfig',
    getSettlementInfo: '/basics-boot/settlement/getSettlementInfo',
    listSettlementSetting: '/basics-boot/settlement/listSettlementSetting',
    listSettlementConfig: '/basics-boot/settlement/listSettlementConfig',
    checkSettlementInfo: '/basics-boot/settlement/checkSettlementInfo',
    addOrModifySettlementInfo: '/basics-boot/settlement/addOrModifySettlementInfo',
    delApplyMessage: '/basics-boot/memberManagement/delApplyMessage',
    reCallSettlementInfo: '/basics-boot/settlement/reCallSettlementInfo',
    signOutSettleInfo: '/basics-boot/memberManagement/signOutSettleInfo',
    renewalApplication: '/basics-boot/settlement/renewalApplication',

    getSettlementGlobal: '/basics-boot/settlement/getSettlementGlobal',
    listApplyMessage: '/basics-boot/memberManagement/listApplyMessage',
    listPayMessage: '/basics-boot/memberManagement/listPayMessage',
    checkOtherType: '/basics-boot/memberManagement/checkOtherType'

  }
}
Vue.prototype.$api = api

export default api



// WEBPACK FOOTER //
// ./src/axios/api.js